import classNames from 'classnames';
import { FC } from 'react';

import { IcCommentsIcon } from '@gem/icons';
import { customScrollStyles, IconButton } from '@gem/ui-kit';

import { MessageViews } from 'APP/components/MessageViews/MessageViews';
import { ReactionButton } from 'APP/components/ReactionButton/ReactionButton';
import { Reactions } from 'APP/components/Reactions/Reactions';
import TextRenderer from 'APP/components/TextRendererCollapsed';

import { IMediaGalleryFile, TCloseHandler } from '../MediaGallery.types';
import { useMediaGallerySidebarPresenter } from './MediaGallerySidebar.presenter';
import styles from './MediaGallerySidebar.styles.m.css';

interface IMediaGallerySidebarProps {
  file: IMediaGalleryFile;
  onClose: TCloseHandler;
}

export const MediaGallerySidebar: FC<IMediaGallerySidebarProps> = ({ file, onClose }) => {
  const presenter = useMediaGallerySidebarPresenter({ file, onClose });

  return (
    <div className={styles.container}>
      <div className={classNames(styles.content, customScrollStyles.container)}>
        {presenter.description && (
          <TextRenderer
            className={styles.descriptionWrapper}
            textClassName={styles.description}
            keyWords={presenter.payload?.keyWords}
            userMentions={presenter.payload?.userMentions}
            groupId={file.message.groupId}
          >
            {presenter.description}
          </TextRenderer>
        )}

        <Reactions
          message={file.message}
          className={styles.reactions}
          theme="3"
        />

        {presenter.isShowFooter && (
          <>
            <hr className={styles.divider} />
            <div className={styles.footer}>
              <ReactionButton
                message={file.message}
                buttonTheme="21"
              />

              {presenter.canLeaveComment && (
                <IconButton
                  className={styles.commentsButton}
                  Icon={IcCommentsIcon}
                  theme="21"
                  text={presenter.commentsCount}
                  onClick={presenter.onCommentsClick}
                />
              )}

              <MessageViews
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                message={file.message}
                className={styles.views}
                showStatus={false}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
